import { render, staticRenderFns } from "./UsedIcon.vue?vue&type=template&id=157104c6&"
import script from "./UsedIcon.vue?vue&type=script&lang=ts&"
export * from "./UsedIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports